import {Model} from "@vuex-orm/core";

export default class AllowanceProductDetailComposition extends Model {
    static entity = 'productAllowanceProductDetailCompositions'

    static primaryKey = ['product_allowance_id', 'product_detail_composition_id']

    static fields() {
        return {
            product_allowance_id: this.number(null).nullable(),
            product_detail_composition_id: this.number(null).nullable(),
        }
    }
}
